import styled from 'styled-components';

export const LoaderStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;

  @keyframes spinner-grow {
    0% {
      transform: scale(0);
    }
    50% {
      opacity: 1;
      transform: none;
    }
  }

  span {
    display: inline-block;
    height: 42px;
    width: 42px;
    border-radius: 50%;
    background-color: #cdcdcd;

    opacity: 0;
    animation: 0.75s linear infinite spinner-grow;
  }
`;
